import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch sales invoices with optional filters
export const getSalesInvoices = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales invoices:", error);
    throw error;
  }
};

// API to insert or update a sales invoice
export const saveSalesInvoice = async (invoiceData) => {
  try {
    console.log("API call - saveSalesInvoice:", invoiceData);
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/save`, invoiceData, {
      headers: getAuthHeader(),
    });
    console.log("API response - saveSalesInvoice:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - saveSalesInvoice:", error);
    throw error;
  }
};

// API to get sales invoice by ID
export const getSalesInvoiceById = async (invoiceId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get`, { Invoice_Id: invoiceId }, {
      headers: getAuthHeader(),
    });
    return response.data?.[0] || null;
  } catch (error) {
    console.error("Error fetching sales invoice by ID:", error);
    throw error;
  }
};

// API to get sales invoice for return
export const getSalesInvoiceForReturn = async (invoiceId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get-sales-invoice-for-return`, {
      Invoice_Id: invoiceId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales invoice for return:", error);
    throw error;
  }
};

// API to get sales return by ID
export const getSalesReturnById = async (returnInvoiceId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get-return-by-id`, {
      Return_Invoice_Id: returnInvoiceId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales return by ID:", error);
    throw error;
  }
};

// API to get next invoice number (supports return mode)
export const getNextSalesInvoiceNumber = async (businessId, isReturn = false, returnOriginalInvoiceNo = null) => {
  try {
    const payload = {
      Business_Id: businessId,
      IsReturn: isReturn
    };
    
    if (isReturn && returnOriginalInvoiceNo) {
      payload.Return_Original_InvoiceNo = returnOriginalInvoiceNo;
    }
    
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get-next-invoice-number`, payload, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting next sales invoice number:", error);
    throw error;
  }
};

// API to export invoice report to Excel
export const exportInvoiceReportToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `InvoiceReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting invoice report:", error);
    throw error;
  }
};

// API to get invoice for print
export const getInvoiceForPrint = async (invoiceId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalesInvoice/get-invoice-for-print`, {
      Invoice_Id: invoiceId
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching invoice for print:", error);
    throw error;
  }
};

// API to get customer advance balance
export const getCustomerAdvanceBalance = async (customerId, businessId, branchId = null) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/get-customer-advance-balance`,
      {
        CustomerId: customerId,
        BusinessId: businessId,
        BranchId: branchId
      },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting customer advance balance:", error);
    throw error;
  }
};

// API to get customer outstanding credit
export const getCustomerOutstandingCredit = async (customerId, businessId, branchId = null) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Receipt/get-customer-outstanding-credit`,
      {
        CustomerId: customerId,
        BusinessId: businessId,
        BranchId: branchId
      },
      { headers: getAuthHeader() }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting customer outstanding credit:", error);
    throw error;
  }
};

